import { useEffect, useState } from 'react';

export default function WaveformVisualizer() {
  const [bars, setBars] = useState<number[]>([]);
  
  useEffect(() => {
    // Generate 40 bars with initial values
    setBars(Array.from({ length: 40 }, () => Math.random() * 0.7 + 0.3));
  }, []);
  
  useEffect(() => {
    if (bars.length === 0) return;
    
    const interval = setInterval(() => {
      setBars(prev => prev.map(() => Math.random() * 0.8 + 0.2));
    }, 800);
    
    return () => clearInterval(interval);
  }, [bars.length]);
  
  return (
    <div className="waveform">
      <div className="waveform-bars">
        {bars.map((height, i) => (
          <div
            key={i}
            className="waveform-bar"
            style={{
              height: `${height * 100}%`,
              animationDelay: `${i * 0.05}s`,
              background: `linear-gradient(180deg, 
                rgba(107, 76, 154, ${0.4 + height * 0.6}) 0%, 
                rgba(61, 90, 128, ${0.3 + height * 0.4}) 100%)`
            }}
          />
        ))}
      </div>
    </div>
  );
}
